"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowNewInspectorTabConfig = void 0;
const zod_1 = require("zod");
exports.ShowNewInspectorTabConfig = zod_1.z.enum(["off", "on", "control"]);
//# sourceMappingURL=showNewInspectorTabConfig.js.map